import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import Logo from '../../static/img/lunar-logo.svg';
import '../../static/style/fonts.css';

const Document = ({ data, pageContext, ...props }) => {
  const content = data.markdownRemark;
  const isLunarBlock = pageContext.isLunarBlock;
  const isLunarPayments = pageContext.isLunarPayments;

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
        <style type="text/css">{`
          body {
            background-color: #fff;
          }
        `}</style>
      </Helmet>
      <StyledLogo>
        <img src={Logo} alt="Lunar Logo" />
      </StyledLogo>
      <StyledDocument dangerouslySetInnerHTML={{ __html: content.html }} />
      <DocumentFooter
        isLunarPayments={isLunarPayments}
        isLunarBlock={isLunarBlock}
      />
    </>
  );
};

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
    }
  }
`;

export const DocumentFooter = ({ isLunarPayments, isLunarBlock }) => {
  if (isLunarPayments) {
    return (
      <StyledFooter>
        Lunar Payments ApS, Hack Kampmanns Plads 10 DK-8000 Aarhus C, CVR nr.
        36683279
      </StyledFooter>
    );
  } else if (isLunarBlock) {
    return (
      <StyledFooter>
        Lunar Block A/S, Hack Kampmanns Plads 10 DK-8000 Aarhus C, CVR nr.
        38808117
      </StyledFooter>
    );
  }

  return (
    <StyledFooter>
      Lunar Bank A/S, Hack Kampmanns Plads 10 DK-8000 Aarhus C, CVR nr. 39697696
    </StyledFooter>
  );
};

export default Document;

const BaseStyling = styled.div`
  * {
    box-sizing: border-box;
  }

  font-family: 'Sharp-Grotesk-Book-20', sans-serif;
  padding: 24px;
  padding-top: 12px;
  max-width: 720px;
  margin: 0 auto;

  h1 {
    font-family: 'Sharp-Grotesk-SmBold-20', sans-serif;
    font-size: 40px;
    line-height: 51px;
  }

  h2 {
    font-family: 'Sharp-Grotesk-SmBold-20', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 31px;
    margin-top: 48px;
  }

  h3 {
    font-family: 'Sharp-Grotesk-SmBold-20', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 23px;
    margin-top: 36px;
  }

  h4 {
    font-family: 'Sharp-Grotesk-SmBold-20', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
  }

  h5 {
    font-family: 'Sharp-Grotesk-SmBold-20', sans-serif;
    font-style: normal;
    font-weight: normal;
    line-height: 24px;
    font-size: 16px;
  }

  strong {
    font-family: 'Sharp-Grotesk-SmBold-20', sans-serif;
  }

  p,
  a {
    line-height: 24px;
    font-size: 16px;
  }

  a {
    text-decoration: none;
    color: #0085ff;
  }

  ul,
  ol {
    padding-left: 20px;
    margin-top: 15px;
    margin-bottom: 15px;

    li  {
      font-size: 16px;
      line-height: 24px;
      padding-top: 9px;
      padding-bottom: 9px;
    }
  }

  img {
    margin: 16px 0;
  }

  sup {
    font-size: 10px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #e9e9ed;
    margin-bottom: 32px;
  }

  thead th {
    text-align: left;
    border-right: 1px solid #e9e9ed;
    font-family: 'Sharp-Grotesk-Book', sans-serif;
  }

  td,
  th {
    border-right: 1px solid #e9e9ed;
    padding: 10px 16px;
    vertical-align: top;
    line-height: 24px;
    font-size: 16px;
    min-width: 120px;
  }

  tr {
    border-bottom: 1px solid #e9e9ed;
  }

  p.footnote {
    font-size: 12px;

    a {
      font-size: 12px;
    }
  }

  .hidden-table-header {
    thead {
      display: none;
    }
  }
`;

const StyledDocument = styled(BaseStyling)`
  background-color: white;
  color: black;
  padding-bottom: 3px;

  img {
    width: 100%;
  }
`;

const StyledLogo = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 52px;
  padding-bottom: 45px;

  img {
    width: 60px;
    height: 60px;
  }
`;

const StyledFooter = styled(StyledDocument)`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 24px;
  padding-bottom: 112px;
  color: rgba(0, 0, 0, 0.5);
`;
